import { resolveContext } from "../global.js";
import { expandSchema, } from "../schema/mod.js";
import { decode } from "../decoder.js";
import { QueryBuilder } from "./query_builder.js";
import { QueryEngineProxy } from "../engine/query_engine_proxy.js";
export const createResource = (spec, context, engine) => new Resource(spec, context, engine);
export class Resource {
    constructor(schema, context, engine) {
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "engine", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queryBuilder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.schema = expandSchema(schema);
        this.context = resolveContext(context);
        this.engine = new QueryEngineProxy(this.context, engine);
        this.queryBuilder = new QueryBuilder(this.schema, this.context);
    }
    decode(graph) {
        return decode(graph, this.schema, this.context);
    }
    async count() {
        const q = this.queryBuilder.countQuery();
        // TODO: console.log(q);
        const bindings = await this.engine.queryBindings(q);
        return parseInt(bindings[0].get("count").value);
    }
    //exists(entity: Identity) {}
    async query(sparqlConstructQuery) {
        const graph = await this.engine.queryGraph(sparqlConstructQuery);
        return this.decode(graph);
    }
    async find(where, limit) {
        const q = this.queryBuilder.getQuery(where, limit);
        // TODO: console.log(q);
        const graph = await this.engine.queryGraph(q);
        return this.decode(graph);
    }
    async findByIri(iri) {
        const results = await this.findByIris([iri]);
        return results.length > 0 ? results[0] : undefined;
    }
    async findByIris(iris) {
        const q = this.queryBuilder.getByIrisQuery(iris);
        // TODO: console.log(q);
        const graph = await this.engine.queryGraph(q);
        return this.decode(graph);
    }
    updateQuery(query) {
        // TODO: console.log(query);
        return this.engine.queryVoid(query);
    }
    insert(...entities) {
        const q = this.queryBuilder.insertQuery(entities);
        return this.updateQuery(q);
    }
    insertData(...quads) {
        const q = this.queryBuilder.insertDataQuery(quads);
        return this.updateQuery(q);
    }
    update(...entities) {
        const q = this.queryBuilder.updateQuery(entities);
        return this.updateQuery(q);
    }
    delete(...identities) {
        const iris = identities.map((identity) => {
            return typeof identity === "string" ? identity : identity.$id;
        });
        const q = this.queryBuilder.deleteQuery(iris);
        return this.updateQuery(q);
    }
    deleteData(...quads) {
        const q = this.queryBuilder.deleteDataQuery(quads);
        return this.updateQuery(q);
    }
}
